import { cn } from '@/lib/utils'

export type Source = 'redeem' | 'campaign'

const SOURCE: Record<Source, { label: string; className: string }> = {
  redeem: { label: '리딤', className: 'text-source-redeem border-source-redeem/35' },
  campaign: { label: '캠페인', className: 'text-source-campaign border-source-campaign/35' },
}

/** Which programme a post belongs to. The two are run apart on purpose — a
 *  desk post written by hand and a campaign draft never share a queue — so a
 *  list that shows both marks each row. */
export function SourceTag({ source, className }: { source: Source; className?: string }) {
  const s = SOURCE[source]
  return (
    <span
      className={cn(
        'inline-flex h-[18px] shrink-0 items-center rounded border px-1.5 text-micro font-semibold',
        s.className,
        className,
      )}
    >
      {s.label}
    </span>
  )
}
